import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { BlockField } from "..";
export const BlockFragment = ({ children, queryVariables, onCatch, similarResidentsControl, }) => {
    return (_jsx(_Fragment, { children: children.map(block => (_jsx(BlockField, { block: block, queryVariables: queryVariables, onCatch: onCatch, similarResidentsControl: similarResidentsControl }, block.id))) }));
};
